import { Controller } from '@hotwired/stimulus'
import TurboClient from '../api/TurboClient'
import { GoogleCaptchaV3Service } from '../api/Google/captchaV3.service'

export default class extends Controller {
  static values = { siteKey: String }

  submit(event) {
    event.preventDefault()
    const form = this.element

    if (!form.checkValidity()) {
      form.reportValidity()
      return
    }

    const button = event.currentTarget
    const siteKey = this.siteKeyValue
    button.disabled = true

    GoogleCaptchaV3Service.verifyCaptcha(token => {
      let turboClient

      if (token) {
        turboClient = new TurboClient(form, {
          extraFormData: {
            'g-recaptcha-response': token,
          },
        })
      } else {
        turboClient = new TurboClient(form)
      }
      turboClient.perform().then(fetchResponse => {
        const isRedirect =
          fetchResponse.response?.redirected ||
          fetchResponse.response?.headers?.get('X-TURBO-STREAM-REDIRECT-TO')

        if (isRedirect) {
          this.dispatch('success')
        } else {
          button.disabled = false
        }
      })
    }, siteKey)
  }
}
